/**
 * Who the agent writes as, from the Angle profile. The identity strip over
 * every page and the Angle page read this one helper, so they always say the
 * same thing.
 */
export type WritingLevel = 'guest' | 'none' | 'thin' | 'full'

export interface WritingStatus {
  level: WritingLevel
  /** Who, after "Writing as". */
  name: string
  /** A short qualifier after the name, when there is one. */
  note?: string
  /** The action that makes the voice better. */
  cta: string
  stories: number
  facts: number
  rules: number
  hasAngle: boolean
}

/** Fewer stories, facts and voice rules than this reads as thin. */
const THIN_BELOW = 6

export function writingStatus(profile: any, isGuest: boolean): WritingStatus {
  const stories = profile?.allowedStorySources?.length || 0
  const facts = profile?.verifiedFacts?.length || 0
  const rules = profile?.voiceRules?.length || 0
  const hasAngle = Boolean(profile?.shortBio || profile?.topicsToOwn?.length)
  const counts = { stories, facts, rules, hasAngle }
  if (isGuest) return { level: 'guest', name: 'Ada Merrow', note: 'made up', cta: 'Use your own', ...counts }
  if (!hasAngle) return { level: 'none', name: 'a generic bot', cta: 'Set your angle', ...counts }
  if (stories + facts + rules < THIN_BELOW) return { level: 'thin', name: 'you', note: 'thin on detail', cta: 'Add detail', ...counts }
  return { level: 'full', name: 'you', cta: 'Go deeper', ...counts }
}
